export interface ESignType {
  userSignatureId: number;
  revisionNumber: number;
  signoffDate: string;
  signoffStatusId: number;
  signoffName: string;
  signId: number;
}

export const EMPTY_SIGNED_TYPE: ESignType = {
  userSignatureId: 0,
  revisionNumber: 0,
  signoffDate: '',
  signoffStatusId: 0,
  signoffName: '',
  signId: 0
};

export interface ESignHistoy {
  revisions: ESignRevision[];
}

export interface ESignRevision {
  number: number;
  date: string;
  link: string;
}
